module.exports = __webpack_public_path__ + "img/timer.bd9e8433.svg";